import { MyStuffFeatureContent, MyStuffItemPlaybackAction } from './mystuff';
import { DVString, WatchlistAction } from './shared';
import { CustomerReviews, MaturityRatingProps } from './hover'
import { HoverMessages } from './hover';

export enum ChannelWPSTypes {
    ChannelItems = 'atv.wps#ChannelItems',
    ChannelEmptyMessage = 'atv.wps#ChannelEmptyMessage'
}

export interface ChannelContent {}

export interface ChannelEmptyMessage extends ChannelContent{
    title: string;
    message: DVString;
    icon?: string;
    __type: ChannelWPSTypes.ChannelEmptyMessage
}

export interface ChannelTitle{
    titleID: string;
    title: string;
    href: string;
    imageSrc: string;
    synopsis?: string,
    releaseYear?: number,
    contentMaturityRating?: MaturityRatingProps,
    runTime?: string,
    hasSubtitles: boolean,
    watchlistAction?: WatchlistAction,
    playbackAction?: MyStuffItemPlaybackAction,
    isNewHover: boolean,
    messages: HoverMessages,
    customerReviews?: CustomerReviews 
}

export interface ChannelCarousel{
    collections: ChannelTitle[];
    seeMoreUrl: ChannelLink;
    fromChannelText: string;
}

export interface ChannelItem{
    renewalDate: string;
    name: string;
    price?: string;
    logo?: string;
    maybeCarousel?: ChannelCarousel;
}

export interface ChannelItems extends ChannelContent{
    items: ChannelItem[];
    manageSubscription: ChannelLink;
    epgIngress: ChannelLink;
    browseChannel: DVString;
    __type: ChannelWPSTypes.ChannelItems

}

export interface ChannelLink{
    label: string,
    url: string
}

export type ChannelContentType = ChannelItems | ChannelEmptyMessage

export interface ChannelOutput extends MyStuffFeatureContent {
    content : ChannelContentType;
    debug?: object;
}

export interface ChannelArgs {}

export type ChannelPackshotProps= ChannelTitle & {
    showHover: boolean
}